import { rest } from 'msw'
import { Profile } from 'types/types'
import { LoginUserResponse } from 'types/users'
import mockUnauthorizedError from '../../../__mocks__/Auth/loginError.json'
import mockLoginUserResponse from '../../../__mocks__/Auth/loginUserResponse.json'
import mockRecaptchaScoreError from '../../../__mocks__/Auth/recaptchaScoreError.json'
import mockProfile from '../../../__mocks__/profile.json'

export const postLoginUser = rest.post<LoginUserResponse>(
  `${API_URL}/api/login`,
  async (req, res, ctx) => {
    return res(ctx.json(mockLoginUserResponse))
  }
)

const getUserProfile = rest.get<Profile>(`${API_URL}/api/user/profile`, async (req, res, ctx) => {
  return res(ctx.json(mockProfile))
})

export const unauthorizedHandlerException = rest.post(
  `${API_URL}/api/login`,
  async (req, res, ctx) => {
    return res(ctx.status(401), ctx.json(mockUnauthorizedError))
  }
)

export const recaptchaLowScoreException = rest.post(
  `${API_URL}/api/login`,
  async (req, res, ctx) => {
    return res(ctx.status(400), ctx.json(mockRecaptchaScoreError))
  }
)

export const tooManyRequestsException = rest.post(`${API_URL}/api/login`, async (req, res, ctx) => {
  return res(ctx.status(429))
})

export const twoFAIncorrectException = rest.post(`${API_URL}/api/login`, async (req, res, ctx) => {
  return res(ctx.status(412))
})

export const reissueToken = rest.post(`${API_URL}/api/login/reissue`, async (req, res, ctx) => {
  return res(
    ctx.status(200),
    ctx.json({
      username: 'user_name',
      roles: ['ROLE_USER'],
      token_type: 'Hawk',
      access_token: 'access_token',
      secret: 'secret',
    })
  )
})

export default [
  postLoginUser,
  getUserProfile,
  unauthorizedHandlerException,
  twoFAIncorrectException,
  tooManyRequestsException,
  reissueToken,
]
